import styles from "./FormEmailTemplate.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import FixedLogoWithName from "../../components/FixedLogoWithName/FixedLogoWithName";
import IconAndName from "../../components/IconAndName/IconAndName";
import { IoAddCircleOutline } from "react-icons/io5";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
  {
    _id: "gnswkgnseknsg1",
    TemplateName: "king",
    color: "green",

    Subject: "King",
    Label: "0",
    Templatetype: ["3A", "3W", "3S"],
    Updatedby: "8",

    Actions: ["Edit", "Delete"],
  },
];

function FormEmailTemplate() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleaddTemplate = () => {
    dispatch(openModal("addTemplate"));
  };
  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        TemplateName: (
          <span style={{ color: item.color || "green", fontWeight: 400 }}>
            {item.TemplateName}
          </span>
        ),

        Subject: item.Subject,
        Label: item.Label,

        Templatetype: item.Templatetype,
        Updatedby: item.Updatedby,
        Actions: (
          <Action
            key={item._id}
            options={item.Actions || ["Edit", "Delete"]}
            onSelect={(opt) => {
              console.log(`Selected "${opt}" for ${item.TemplateName}`);
              if (opt === "Edit") {
                console.log("Edited");
              } else if (opt === "Delete") {
                dispatch(openModal("delete"));
              }
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Template Name", accessor: "TemplateName" },
    { title: "Subject", accessor: "Subject" },
    { title: "Label", accessor: "Label" },
    { title: " Template type", accessor: "Templatetype" },
    { title: "Updated by", accessor: "Updatedby" },
    { title: "Actions", accessor: "Actions" },
  ];

  return (
    <>
      <div className={styles.pageWrapper}>
        <div className={styles.headerContainer}>
          {/* Status boxes */}

          {/* Search and Filters */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.searchandfilter}>
                <div className={styles.search}>
                  <SearchBar
                    placeholder="Search by name "
                    onChange={(e) => console.log(e.target.value)}
                  />
                </div>

                  <Dropdown
                    bgColor="var(--Utility_Color1)"
                    label=" Templates"
                    options={[
                      "YourTemplate1",
                      "YourTemplate2",
                      "YourTemplate3",
                    ]}
                  />
                
              </div>

              <div className={styles.button}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Template"
                  bgColor="Primary_Color"
                  onClick={handleaddTemplate}
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
        <div styles={styles.footer}>{<CopyRight />}</div>
      </div>
    </>
  );
}

export default FormEmailTemplate;
